import { Volume2, VolumeX } from "lucide-react";

export default function SoundToggle({ enabled, onToggle }) {
  return (
    <button
      type="button"
      data-testid="sound-toggle-button"
      onClick={onToggle}
      aria-label={enabled ? "Mute ambient sound" : "Unmute ambient sound"}
      className="pointer-events-auto fixed top-6 right-6 z-50 flex h-11 w-11 items-center justify-center border border-[#01FFFF]/30 bg-black/40 backdrop-blur-md transition-colors duration-200 hover:border-[#01FFFF] hover:bg-[#01FFFF]/10"
    >
      {enabled ? (
        <Volume2 size={16} className="text-[#01FFFF]" />
      ) : (
        <VolumeX size={16} className="text-[#8A9AAB]" />
      )}
    </button>
  );
}
